import { UIDiv } from '@ui';

export default class UICommentText extends UIDiv {
  constructor() {
    super();
    this.setAttribute('contenteditable', true);
    this.setClass('textarea mention-input');
    this.dom.spellcheck = false;

    this.placeholder = '';
    this.plugins = new Set();

    // Updated event listeners
    this.onInput(() => this.togglePlaceholder());
    this.onFocus(() => this.togglePlaceholder());
    this.onBlur(() => this.togglePlaceholder());
  }

  // Plugin system
  addPlugin(plugin) {
    this.plugins.add(plugin);
    return this;
  }

  removePlugin(plugin) {
    this.plugins.delete(plugin);
    if (plugin.destroy) plugin.destroy();
    return this;
  }

  togglePlaceholder() {
    const isEmpty = !this.dom.textContent.trim();

    if (isEmpty && !this.dom.matches(':focus')) {
      // Show placeholder when empty and not focused
      this.dom.innerHTML = `<span class="placeholder text-gray-400 pointer-events-none">${this.placeholder}</span>`;
    } else if (
      this.dom.matches(':focus') &&
      this.find('.placeholder').length > 0
    ) {
      // Clear placeholder on focus if empty
      this.dom.innerHTML = '';
    }
  }

  getValue() {
    const placeholderSpan = this.find('.placeholder')[0];
    if (placeholderSpan) return '';

    // Create a temporary div to handle the content
    const tempDiv = new UIDiv();
    tempDiv.dom.innerHTML = this.getInnerHTML();
    // Replace all reference spans with their text content
    [
      '.mention-span',
      '.task-reference',
      '.ai-command-reference',
      '.item-reference',
    ].forEach(selector => {
      tempDiv.find(selector).forEach(span => {
        span.dom.replaceWith(span.dom.textContent);
      });
    });

    return tempDiv.dom.textContent;
  }

  getCursorPosition() {
    const selection = window.getSelection();
    if (!selection.rangeCount) return -1;

    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(this.dom);
    preCaretRange.setEnd(range.startContainer, range.startOffset);

    // Handle multiline text by counting actual characters
    let position = 0;
    const walker = document.createTreeWalker(
      this.dom,
      NodeFilter.SHOW_TEXT,
      null,
      false,
    );

    let node;
    while ((node = walker.nextNode())) {
      if (node === range.startContainer) {
        position += range.startOffset;
        break;
      }
      position += node.length;
    }

    return position;
  }

  setValue(value) {
    this.dom.innerText = value;
    this.togglePlaceholder();
    return this;
  }

  setPlaceholder(value) {
    this.placeholder = value;
    this.togglePlaceholder();
    return this;
  }

  setRows(value) {
    this.dom.rows = value;
    return this;
  }
}
